// extracted by mini-css-extract-plugin
module.exports = {"commonToolsStyle":"_1X5Hc1yhWa7z-TQ3WI7efR"};